module.exports = __webpack_public_path__ + "static/media/oval.66aeb4d0.png";